const ERROR_TEXTS = {
  "4": "Растяните губы и улыбнитесь",
  "5": "Вы делаете слишком быстро, держите подольше",
  "6": "Смотрите в камеру, не отворачивайтесь",
  "7": "Округлите губы как будто говорите  УУУУ",  
  "8": "У вас 10 секунд для повтора",
  "31": "Начинайте",
  "60": "Больше покажите зубы",
  "61": "Сомкните зубы",
  "62": "Не высовывайте язык",
  "63": "Растяните губы пошире, чтобы были видны все зубы",
  "64": "Откройте рот пошире",
  "140": "Не закрывайте глаза, держите их открытыми",
  "141": "Поднимите обе брови, а не одну",
  "142": "Поднимите брови выше",
  "160": "Откройте рот ещё шире",
  "201": "Откройте рот и округлитн губы как будто говорите аааа",
  "15": "Сведите губы вместе, вытяните их в поцелуе",
  "16": "Не открывайте рот так широко",
  "19": "Не смыкайте губы слишком плотно",
  "20": "Сомкните губы посильнее",
  "21": "не открывайте рот слишком широко!",
  "22": "Опустите подбородок",
  "206": "Поднимите уголки губ выше"
};

// Коды-подсказки: сервер шлёт их посреди повтора, это не оценка.
const HINT_CODES = ["31", "8"];

export class FeedbackMapper {
  static isHintOnly(errorCodes) {
    return Array.isArray(errorCodes) && errorCodes.length > 0 && errorCodes.every(code => HINT_CODES.includes(String(code)));
  }

  // Сервер шлёт finished и числом, и строкой ("1", "True").
  static isFinished(value) {
    return value === true || Number(value) === 1 || String(value).toLowerCase() === "true";
  }

  static getErrorText(errorCodes) {
    if (!Array.isArray(errorCodes) || errorCodes.length === 0) return "Попробуй еще раз";
    const messages = errorCodes.map(code => ERROR_TEXTS[String(code)] || `Код: ${code}`);
    return messages.join(", ");
  }

  static checkLocalErrors(localErrors) {
    if (!localErrors) return false;
    for (let obj of localErrors) {
      for (let [er_id, cat_id] of Object.entries(obj)) {
        if (cat_id !== "0") return true;
      }
    }
    return false;
  }
}

if (typeof window !== "undefined") {
  window.EzSpeechCv = window.EzSpeechCv || {};
  window.EzSpeechCv.FeedbackMapper = FeedbackMapper;
}